<template>
    <div class="EvaluationThird" id="EvaluationThird" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.7)" element-loading-text="文件正在下载，请稍等" element-loading-spinner="el-icon-loading">
      <div class="evaluateMain">
        <div class="table_panel">
            <span style="font-size:14px;;font-weight:600">边坡稳定性野外评价指标</span>
        </div>
        <div class="table">
            <el-table
                :header-cell-style="{background:'#335ABB',color:'#FFF'}"
                stripe
                :data="tableData"
                style="width: 100%;font-size:14px;">
                <el-table-column
                    prop="standard"
                    label="评价标准"
                    align="center"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="definition"
                    label="定义"
                    align="center"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="accord"
                    align="center"
                    label="定性判别标准">
                </el-table-column>
            </el-table>
            <div class="table_panel">
                <span style="margin-right:25%;color:#E68F02;" @click="downloadLeft()">煤炭工业露天矿边坡工程监测规范（GB 51214-2017）</span>
                <span style="color:#E68F02;"  @click="downloadRight()">滑坡防治工程勘查规范（DZT0218-2006）</span>
            </div>
        </div>
    </div>
    </div>
</template>

<script>

    export default {
        name: 'EvaluationThird',
        data() {
            return {
                tableData: [{
                    standard: '稳定的',
                    definition: '在设计工况(荷载组合，下同)和特殊工况条件(暴雨等)下均是稳定的。',
                    accord: '滑坡外貌特征后期改造很大,滑坡洼地基本难以辨认,滑体地面坡度平缓(≤10°),前缘临空低缓(一般<5m,坡度<15°),滑体内冲沟切割已至滑床;滑面起伏较大,且倾角平缓(≤10°),滑面饱和阻抗比大于0.8;滑坡残体透水性良好,剪出口一带泉群分布且流量较大;滑距较远,能量已充分释放,残体处于稳定状态;滑坡周边没有新的堆积物加载来源,滑坡前缘已形成河流侵蚀的稳定坡型或有河流堆积。经分析和实地调查，找不出可导致整体复活的主要动力因素，人为动力因素很弱或不存在。'
                }, {
                    standard: '基本稳定的',
                    definition: '在设计工况条件下是稳定的，在特殊工况条件下其稳定型有所降低，有可能局部产生变形，但整体仍是稳定的。',
                    accord: '滑坡外貌特征后期改变较大,滑坡洼地能辨认但不明显或略有封闭，滑体地面平均坡度较缓(10°～20°)，滑坡前缘临空比较低缓(高度为15m～30m, .坡度为15°～20°),滑体内沟谷已切至滑床，滑面形态起伏,滑面平均倾角小于或等于20° ,滑面阻抗比为0.6～0.8;滑坡残体透水性良好;滑距较远，能量已充分释放；滑坡周围无新的堆积物加载来源，滑坡前缘已形成河流侵蚀的稳定坡型。经分析和实地调查，在特殊工况条件下整体稳定性有所降低,但仅可能产生局部变形破坏。'
                }, {
                    standard: '潜在不稳定的',
                    definition: '在现状条件下是稳定的,但安全储备不高,略高于临界状态。在设计工况条件下向不稳定方向发展,在特殊工况条件下有可能失稳。',
                    accord: '滑坡外貌特征后期改造不大,后缘滑坡洼地封闭或半封闭;滑体平均坡度中等(20°～30°),滑坡前缘临空较陡(高度为30m～50m,坡度为20°～30°),滑体内沟谷切割中等;滑面形态为靠椅状或平面状,滑面平均倾角为20°～30° ,滑面阻抗比为0.4～0.6;滑坡残体透水性一般，滑距不太远, 能量释放不充分;滑坡后缘有加载堆积或有一定数量的危岩体为加载来源，滑坡前缘受冲刷尚未形成稳定坡型,且具有局部坍塌产生,整体尚无明显变形迹象。经实地调查和定性分析,在一-般工况条件下.是稳定的,但安全储备不高,在特殊工况条件下有可能整体失稳。'
                }, {
                    standard: '不稳定的',
                    definition: '在现状条件下即近于临界状态，且向不稳定方向发.展,在设计工况条件下将部分失稳。',
                    accord: '滑坡外貌特征明显,滑坡洼地一般封闭明显;滑体坡面平均坡度较陡（大于30°），滑坡前缘临空较陡(高度大于50m,坡度大于30°),滑体内沟谷切割较浅。滑面呈靠椅状或平面状,滑面平均倾角大于30°,滑面阻抗比小于0.4,滑体结构松散,透水性差;滑距短,滑坡残体保留较多，剪出口以下脱离滑床的体积较少;滑坡.有加载来源，滑坡前缘受冲刷,有坍塌产生;滑体上近期有明显变形破坏迹象。变形迹象为滑坡变形配套产物:后缘弧形裂缝或塌陷,两侧羽状开裂，前缘膨胀、鼓丘等。经实地调查和分析,滑体目前接近于临界状态,且正在向不稳定方向发展,在特殊工况条件下有可能大规模失稳。'
                }],
                loading: false,
            };
        },
        mounted:function(){

        },
        methods:{
            downloadLeft(){
                this.loading = true;
                const req =  '煤炭工业露天矿边坡工程监测规范-GB 51214-2017'
                this.$axios.get('/api/monitor/safe/downLoadPdf?fileName='+req, {responseType: 'blob'}).then(res => {
                    if(!res){
                        this.loading = false;
                        return
                    }
                    if(res.data.status==404){
                        this.loading = false;
                        return
                    }
                    const _res = res.data;
                    if(_res.type == 'application/octet-stream'){
                        this.loading = false;
                    }
                    let blob = new Blob([_res], {type: 'application/pdf;charset=UTF-8'});
                    let downloadElement = document.createElement("a");
                    let href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = `煤炭工业露天矿边坡工程监测规范(GB 51214-2017).pdf`;
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                    setTimeout(()=>{this.loading = false;},1500)

                })
            },
            downloadRight(){
                this.loading = true;
                const req ='滑坡防治工程勘查规范-DZT0218-2006'
                this.$axios.get('/api/monitor/safe/downLoadPdf?fileName='+req, {responseType: 'blob'}).then(res => {
                    if(!res){
                        this.loading = false;
                        return
                    }
                    if(res.data.status==404){
                        this.loading = false;
                        return
                    }
                    const _res = res.data;
                    if(_res.type == 'application/octet-stream'){
                        this.loading = false;
                    }
                    let blob = new Blob([_res], {type: 'application/pdf;charset=UTF-8'});
                    let downloadElement = document.createElement("a");
                    let href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = `滑坡防治工程勘查规范(DZT0218-2006).pdf`;
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                    setTimeout(()=>{this.loading = false;},1500)

                })
            }
        }
    }
</script>

<style>

    #EvaluationThird .el-table{
        color: #A7CCF6;
    }

    #EvaluationThird .el-table__row {
        background-color: #0B3A68 !important;
    }

    #EvaluationThird .el-table--striped .el-table__body tr.el-table__row--striped td{
        background-color: #021535;
    }

    #EvaluationThird .el-table td{
        border: unset;
    }

    #EvaluationThird .el-table th.is-leaf{
        border-bottom: none;
    }

</style>

<style scoped>
    @import url('../../assets/css/style.css');
</style>



// WEBPACK FOOTER //
// src/components/evaluation/EvaluationThird.vue